import {useCallback, useMemo} from 'react';
import {useSearchParams} from 'react-router-dom';
import {UseListParamsReturn} from '../../../hooks/listParams';
import {PAGE_PARAM, SEARCH_PARAM, useListSearchParams} from '../../../hooks/useListSearchParams';

export enum ConnectionsTab {
    Active = 'active',
    Requests = 'requests',
    Sent = 'sent',
}

function parseConnectionsTab(searchParams: URLSearchParams): ConnectionsTab {
    const tab = searchParams.get('tab');
    if (tab === ConnectionsTab.Requests) {
        return ConnectionsTab.Requests;
    }
    if (tab === ConnectionsTab.Sent) {
        return ConnectionsTab.Sent;
    }
    return ConnectionsTab.Active;
}

export interface UseConnectionsListSearchParamsReturn extends UseListParamsReturn {
    activeTab: ConnectionsTab;
    setActiveTab: (tab: ConnectionsTab) => void;
}

export function useConnectionsListSearchParams(): UseConnectionsListSearchParamsReturn {
    const [searchParams, setSearchParams] = useSearchParams();
    const {listParams, setListParams} = useListSearchParams();

    const activeTab = useMemo(() => parseConnectionsTab(searchParams), [searchParams]);

    const setActiveTab = useCallback(
        (tab: ConnectionsTab) => {
            if (tab === activeTab) {
                return;
            }

            const params = new URLSearchParams(searchParams);

            params.delete(PAGE_PARAM);
            params.delete(SEARCH_PARAM);

            if (tab === ConnectionsTab.Active) {
                params.delete('tab');
            } else {
                params.set('tab', tab);
            }

            setSearchParams(params, {replace: true});
        },
        [activeTab, searchParams, setSearchParams]
    );

    return {
        listParams,
        setListParams,
        activeTab,
        setActiveTab,
    };
}
